// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BoxPlotOutlinedSvg from "@ant-design/icons-svg/es/asn/BoxPlotOutlined";
import AntdIcon from '../components/AntdIcon';

var BoxPlotOutlined = function BoxPlotOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: BoxPlotOutlinedSvg
  }));
};

BoxPlotOutlined.displayName = 'BoxPlotOutlined';
export default React.forwardRef(BoxPlotOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/BoxPlotOutlined.js
// module id = 677
// module chunks = 0